// extracted by mini-css-extract-plugin
export default {"wrap":"Main_wrap__6kJhg","text":"Main_text__ykOqx","accent":"Main_accent__tErBP","img":"Main_img__vphKP"};